<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Quicksand&display=swap');
@import "~@/assets/_variables.scss";

$small: "screen and (max-width: 1024px)";
$tablet: "screen and (max-width: 700px)";
$mobile: "screen and (max-width: 500px)";

#app {
  font-family: 'Quicksand', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  color: var(--color-text);
}
html {
  font-size: 18px;
  background: var(--color-bg);
}
body {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 100;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  line-height: 1.2;
}
h1 {
  font-size: 6rem;
  font-weight: 300;
  margin: 0;
  @media #{$tablet} {
    font-size: 4rem;
  }
}
h2 {
  font-size: 4rem;
  font-weight: 400;
  margin: 0;
  @media #{$tablet} {
    font-size: 3rem;
  }
}
h3 {
  font-size: 2.2rem;
  font-weight: 100;
  margin: var(--spacing-small) 0;
  @media #{$tablet} {
    font-size: 1.5rem;
  }
}
h4 {
  color: var(--color-text_gray);
  font-size: 1.1rem;
  font-weight: 400;
  margin: var(--spacing-tiny) 0;
}
p {
  line-height: 1.35;
  max-width: 1100px;
}
.hero-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.link {
  color: var(--color-text);
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    color: var(--color-text-hover);
  }
}
.media {
  margin: 0 var(--spacing-small);
}
.email-link {
  color: white;
  text-decoration: none;
  padding: 3px var(--spacing-default);
  background: var(--color-text);
}
.center {
  text-align: center;
  max-width: var(--container-small);
}
.container,
.portfolio {
  max-width: var(--container-default);
  text-size-adjust: 50%;
  padding: 0 var(--spacing-small);
  margin: var(--spacing-large) auto;
}
.portfolio {
  padding: 0;
  margin: 0 auto;
  @media #{$tablet} {
    padding: 0;
  }
}
.content {
  margin-bottom: var(--spacing-default);
}
.text-larger {
  font-size: var(--font-size-larger);
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.first-block {
  margin-top: 0;
}
</style>
